import * as PIXI from "pixi.js";
import QuestionNavigatorRenderer, { NavigatorColor } from "../../../../entities/QuestionNavigator/QuestionNavigatorRenderer";
import addInteractivity from "../../../../../../../../src/utils/addInteractivity";
import { EnumEventBus, eventBus } from "../../../EventBus";
import TestQuestionManager from "../../../TestQuestionManager/TestQuestionManager";
import { CustomCursorType } from "../../../../../../../../src/entities/UI/CustomCursor/CustomCursor";


export default class QuestionNavigatorManager extends PIXI.Container {
  private TestQuestionManager = TestQuestionManager.getInstance();
  private Navigators: QuestionNavigatorRenderer[] = [];

  constructor() {
    super();
    this.addNavigators();
    eventBus.on(EnumEventBus.saveAnswer, () => setTimeout(() => this.markQuestion(), 100));
    eventBus.on(EnumEventBus.startTest, () => this.markQuestion());
    eventBus.on(EnumEventBus.setQuestMode, () => this.markQuestion(true));
    eventBus.on(EnumEventBus.checkedAnswers, (arr: (boolean | null)[]) => {
      this.markQuestionWithAnswers(arr)
      this.setEventMode(true);
    });
  }
  private setEventMode = (v: boolean) => this.Navigators.forEach(e => e.eventMode = v ? "static" : "none");
  private addNavigators() {
    const qLength = this.TestQuestionManager.getQuestionCount();
    this.Navigators = Array(qLength)
      .fill(null)
      .map((_, i) => this.addChild(new QuestionNavigatorRenderer(i + 1)));

    this.Navigators.forEach((e, eI) => {
      const uX = 50;
      const uY = 30;
      const x = uX * (eI % 10 - 4.5);
      const y = 530 + (eI > 9 ? 1 : 0) * uY;

      e.position.copyFrom({ x, y });
      const handleDownFunc = () => eventBus.emit(EnumEventBus.showTestQuestion, eI);
      addInteractivity(e, { handleDownFunc }, CustomCursorType.pointer);

    });
    setTimeout(() => this.setEventMode(false), 200);
  }
  markQuestion(isReset?: boolean) {
    const v = isReset ? -1 : this.TestQuestionManager.getAnswersLength();

    this.Navigators.forEach((n, nI) => {
      nI < v && n.drawBg(NavigatorColor.prev);
      nI == v && n.drawBg(NavigatorColor.curr);
      nI > v && n.drawBg(NavigatorColor.default);
    })
  }
  markQuestionWithAnswers(answers: (boolean | null)[]) {
    answers.forEach((n, nI) => {
      const color = n === null ? NavigatorColor.null : n ? NavigatorColor.true : NavigatorColor.false;
      this.Navigators[nI].drawBg(color);
    })
  }
}